if (!customElements.get('jewel-ring-preview')) {
  customElements.define(
    'jewel-ring-preview',
    class extends HTMLElement {
      connectedCallback() {
        this.baseImage = this.querySelector('.ring-base');
        this.leftImage = this.querySelector('.ring-stone-left');
        this.rightImage = this.querySelector('.ring-stone-right');
        this.birthstones = this.readJson('[data-ring-birthstones]', {});
        this.combinations = this.readJson('[data-ring-combinations]', []);
        this.currentIndex = 0;
        this.current = this.combinations[0] || { left: 'january', right: 'september' };
        this.interacted = false;
        this.interval = null;
        this.abortController = new AbortController();

        document.addEventListener('jewel:birthstones-preview', this.handleSelection, {
          signal: this.abortController.signal,
        });
        document.addEventListener('jewel:birthstones-change', this.handleSelection, {
          signal: this.abortController.signal,
        });

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAutoplay();
      }

      readJson(selector, fallback) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || '');
        } catch (error) {
          return fallback;
        }
      }

      normalize(value) {
        return String(value || '').trim().toLowerCase();
      }

      startAutoplay() {
        if (this.interacted || this.combinations.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }

        const speed = Math.max(1500, Number(this.dataset.autoplaySpeed) || 1800);
        this.interval = window.setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.combinations.length;
          this.showCombination(this.combinations[this.currentIndex]);
        }, speed);
      }

      stopAutoplay() {
        window.clearInterval(this.interval);
        this.interval = null;
      }

      showCombination(combination) {
        if (!combination?.url || !this.baseImage) return;
        this.current = combination;
        this.setResponsiveImage(this.baseImage, combination);
        this.leftImage.hidden = true;
        this.rightImage.hidden = true;
      }

      setResponsiveImage(image, source) {
        const avifSource = image?.parentElement?.querySelector('source[type="image/avif"]');

        if (avifSource) {
          avifSource.srcset = source.srcset || '';
        }

        image.src = source.url;
      }

      handleSelection = (event) => {
        if (event.detail?.formId !== this.dataset.formId) return;
        const left = this.normalize(event.detail?.one);
        const right = this.normalize(event.detail?.two);
        if (!left && !right) return;

        this.interacted = true;
        this.stopAutoplay();

        if (left) {
          this.current.left = left;
          this.applyStone(this.leftImage, 'left', left);
        }

        if (right) {
          this.current.right = right;
          this.applyStone(this.rightImage, 'right', right);
        }
      };

      applyStone(image, targetSide, month) {
        const stone = this.birthstones[month];
        if (!image || !stone?.url) return;
        this.setResponsiveImage(image, stone);
        image.style.filter = stone.filter || 'none';
        image.classList.toggle('is-mirrored', stone.sourceSide !== targetSide);
        image.hidden = false;
      }
    }
  );
}
